import axios from "axios";
//http client
// import { UPLOAD_PICTURE } from "./types";
import configData from "./../configData";
import { tokenConfig } from "./authActions";
import {
  BUSINESSCARD_NOTIFICATION,
  DELETE_IMAGES,
  DELETE_PROFILE_PICTURE,
  ITEM_KANBAN_BLOB,
  PICTURE_NOTIFICATION,
  SAVE_IMAGE,
} from "./types";
// import { returnErrors } from "./errorActions";

export const deleteProfilePictures = (info) => (dispatch, getState) => {
  if (info) {
    Object.keys(info).map(function (key, ind) {
      try {
        window.URL.revokeObjectURL(info[key]);
        return;
      } catch (e) {}
    });
  }
  dispatch({
    type: DELETE_IMAGES,
  });
};

export const getProfilePictures = (info) => (dispatch, getState) => {
  // dispatch for redux thunk
  let config = tokenConfig(getState);
  if (config.headers["x-auth-token"]) {
    axios
      .post(
        `${configData.SERVER_URL}getProfilePictures`,
        JSON.stringify(info), // post request must have body,
        config
      )
      .then(function (result) {
        for (let i = 0; i < result.data.length; i++) {
          let signedUrl = result.data[i].url;
          let email = result.data[i].name;
          let firstName = result.data[i].firstName;
          let lastName = result.data[i].lastName;
          if (signedUrl !== "") {
            axios({
              method: "get",
              url: signedUrl,
              responseType: "blob",
              headers: {
                // "Access-Control-Request-Method": "GET",
                // "Content-Type": "image/*",
                "Access-Control-Allow-Origin": "*",
              },
            })
              .then(function (result1) {
                // const reader = new FileReader();
                // reader.onloadend = () =>
                // this.props.onFileLoaded(reader.result1);
                // reader.readAsDataURL(result1.request.response);
                const localImageUrl = window.URL.createObjectURL(
                  result1.request.response
                );
                // let name = intermediateRes[1].name;
                let payload = {
                  [email]: { img: localImageUrl, firstName, lastName },
                };
                // this.props.saveImage(localImageUrl);
                dispatch({
                  type: SAVE_IMAGE,
                  payload,
                  // sending data as payload to reducer
                });
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log("Error", error.message);
                }
              });
          } else {
            let payload = { [email]: "" };
            // console.log("localImagUrl", localImageUrl);
            // this.props.saveImage(localImageUrl);
            dispatch({
              type: SAVE_IMAGE,
              payload,
              // sending data as payload to reducer
            });
          }
        }
      })

      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      });
  }
};

export const pictureUpload = (info, file) => (dispatch, getState) => {
  // dispatch for redux thunk
  dispatch({
    type: PICTURE_NOTIFICATION,
    payload: "Uploading.",
  });
  setTimeout(() => {
    dispatch({
      type: PICTURE_NOTIFICATION,
      payload: "",
    });
  }, 15000);
  let intermediateRes = [];
  axios
    .post(
      `${configData.SERVER_URL}presigned-post-data`,
      JSON.stringify({
        name: info,
      }),
      tokenConfig(getState)
    )
    .then(function (result) {
      let formData = new FormData();
      // formData.append("Content-Type",)
      Object.entries(result.data.data.fields).forEach(([k, v]) => {
        formData.append(k, v);
      });
      formData.append("file", file);

      var signedUrl = result.data.data.url;
      return axios({
        method: "post",
        url: signedUrl,
        data: formData,
        // headers: { "Content-length": 7255190 },
      });
    })
    .then(function (result) {
      axios
        .post(
          `${configData.SERVER_URL}getPresignedUrlGET`,
          JSON.stringify({}), // post request must have body,
          tokenConfig(getState)
        )
        .then(function (result) {
          intermediateRes = result.data.result;
          var signedUrl = intermediateRes[0].url;
          // var signedUrl = result[0].url;
          setTimeout(() => {
            axios({
              method: "get",
              url: signedUrl,
              responseType: "blob",
              headers: {
                "Access-Control-Allow-Origin": "*",
              },
            })
              .then(function (result1) {
                const localImageUrl = window.URL.createObjectURL(
                  result1.request.response
                );
                // let name = "user";
                // let payload = { result[0].name, url: localImageUrl };
                let name = intermediateRes[1].name;
                let firstName = intermediateRes[1].firstName;
                let lastName = intermediateRes[1].lastName;
                let payload = {
                  user: { img: localImageUrl, firstName, lastName },
                  [name]: { img: localImageUrl, firstName, lastName },
                };
                // this.props.saveImage(localImageUrl);
                // dispatch({
                dispatch({
                  type: PICTURE_NOTIFICATION,
                  payload: "Upload success",
                });
                setTimeout(() => {
                  dispatch({
                    type: PICTURE_NOTIFICATION,
                    payload: "",
                  });
                }, 10000);
                dispatch({
                  type: SAVE_IMAGE,
                  payload,
                  // sending data as payload to reducer
                });
              })
              .catch((error) => {
                if (error.response) {
                  // Request made and server responded
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);

                  // dispatch({
                  //   type: PICTURE_UPLOAD_SUCCESS,
                  //   payload: "",
                  //   // sending data as payload to reducer
                  // });
                  // dispatch({
                  //   type: PICTURE_UPLOAD_ERROR,
                  //   payload: error.response.data,
                  //   // sending data as payload to reducer
                  // });
                } else if (error.request) {
                  // The request was made but no response was received
                  console.log(error.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log("Error", error.message);
                }
                // console.log("err img download blob", err);
              });
          }, 4000);
          // }, 4000);

          // return axios({
          //   method: "get",
          //   url: signedUrl.data,
          //   responseType: "blob",
          //   headers: {
          //     "Access-Control-Allow-Origin": "*",
          //   },
          // });
        })
        .then(function (result) {
          let localImageUrl = window.URL.createObjectURL(
            result.request.response
          );

          // let name = intermediateRes[1].name;
          // let payload = { [name]: localImageUrl };
          // this.props.saveImage(localImageUrl);
          // let name = "user";
          // let payload = { name: "user", url: localImageUrl };
          let name = intermediateRes[0].name;
          let payload = { user: localImageUrl, [name]: localImageUrl };

          dispatch({
            type: SAVE_IMAGE,
            payload,
            // sending data as payload to reducer
          });
        })
        .catch((err) => {
          console.log("err img download blob", err);
        });
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const pictureDownload = (info) => (dispatch, getState) => {
  // dispatch for redux thunk
  let config = tokenConfig(getState);
  let intermediateRes = [];
  if (config.headers["x-auth-token"]) {
    axios //TO BE CHANGED!!!!!!!!!!!!!!!
      .post(
        `${configData.SERVER_URL}getPresignedUrlGET`,
        JSON.stringify({}), // post request must have body,
        config
      )
      .then(function (result) {
        intermediateRes = result.data.result;
        var signedUrl = intermediateRes[0].url;
        // return axios.post(signedUrl, formData); //,options
        return axios({
          method: "get",
          url: signedUrl,
          responseType: "blob",
          headers: {
            // "Access-Control-Request-Method": "GET",
            // "Content-Type": "image/*",
            "Access-Control-Allow-Origin": "*",
          },
        });
      })
      .then(function (result) {
        // const reader = new FileReader();
        // reader.onloadend = () =>
        // this.props.onFileLoaded(reader.result);
        // reader.readAsDataURL(result.request.response);
        const localImageUrl = window.URL.createObjectURL(
          result.request.response
        );
        let name = intermediateRes[1].name;
        let firstName = intermediateRes[1].firstName;
        let lastName = intermediateRes[1].lastName;
        let payload = {
          user: { img: localImageUrl, firstName, lastName },
          [name]: { img: localImageUrl, firstName, lastName },
        };

        // this.props.saveImage(localImageUrl);
        dispatch({
          type: SAVE_IMAGE,
          payload,
          // sending data as payload to reducer
        });
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  }
};

export const kanbanBlob = (data) => (dispatch, getState) => {
  axios
    .post(
      `${configData.SERVER_URL}userDownloadFile`,
      JSON.stringify(data),
      tokenConfig(getState)
    )
    .then(function (result) {
      let signedUrl = result.data;
      if (signedUrl !== "") {
        axios({
          method: "get",
          url: signedUrl,
          responseType: "blob",
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }).then((response) => {
          const localImageUrl = window.URL.createObjectURL(
            response.data
          );
          dispatch({ type: ITEM_KANBAN_BLOB, payload: {[data.fileID]: localImageUrl} });
        });
      }
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
    });
}

export const deleteProfilePic = (userId) => (dispatch, getState) => {
  // dispatch for redux thunk

  // this.props.saveImage(localImageUrl);

  dispatch({
    type: DELETE_PROFILE_PICTURE,
    payload: userId,
    // sending data as payload to reducer
  });
};

export const businessCardUpload = (info, file) => (dispatch, getState) => {
  // dispatch for redux thunk
  dispatch({
    type: PICTURE_NOTIFICATION,
    payload: "Uploading.",
  });
  setTimeout(() => {
    dispatch({
      type: PICTURE_NOTIFICATION,
      payload: "",
    });
  }, 15000);
  let intermediateRes = [];
  var s3Key = "";
  axios
    .post(
      `${configData.SERVER_URL}presignedPostDataBusinessCard`,
      JSON.stringify({
        name: info,
      }),
      tokenConfig(getState)
    )
    .then(function (result) {
      console.log("resultled", result);
      let formData = new FormData();
      // formData.append("Content-Type",)
      Object.entries(result.data.data.fields).forEach(([k, v]) => {
        formData.append(k, v);
      });
      formData.append("file", file);

      var signedUrl = result.data.data.url;
      s3Key = result.data.data.fields.key;
      console.log("signedurrl", signedUrl);
      console.log("formddat", formData);
      return axios({
        method: "post",
        url: signedUrl,
        data: formData,
        // headers: { "Content-length": 7255190 },
      });
    })
    .then(function (result) {
      // call chatgpt
      console.log("donnene");

      axios
        .post(
          `${configData.SERVER_URL}postChat`,
          { ...info, origin: "crmFile", s3Key },
          tokenConfig(getState)
        )
        .then((res) => {
          console.log("resssss", res);

          dispatch({
            type: BUSINESSCARD_NOTIFICATION,
            payload: res.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: BUSINESSCARD_NOTIFICATION,
              payload: {},
            });
          }, 500);
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            console.log(error.response.status);
            console.log(error.response.headers);
            console.log(error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
        });
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};
